// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivateDtaWorkflow201Response,
  ActivateDtaWorkflowRequest,
  AddVendorUserRequest,
  ApproveDtaRequest,
  CapabilitySet,
  CapabilitySetListResponse,
  CapabilitySetRequest,
  Comment,
  CommentsListResponse,
  CreateCommentRequest,
  CreateDTAResponse,
  CreateDtaRequest,
  CreateDtaVersionRequest,
  CreateGrantRequest,
  CreateProposalRequest,
  CreateProtocolRequest,
  CreateStudyRequest,
  CreateVendorRequest,
  DTADetails,
  DTAVersion,
  DTAVersionsResponse,
  DaeNotificationsResponse,
  DaeStudiesResponse,
  DaeStudyDetailResponse,
  DeactivateDtaRequestBody,
  DtaListResponse,
  DtaStageResponse,
  DtaSuggestionsResponse,
  DtaThinkingStepsResponse,
  ErrorResponse,
  ExportQuarantineDataResponseContent,
  GetIngestionSpecResponseContent,
  GetQuarantineDataResponseContent,
  GetRecordHistoryResponseContent,
  GetRunChangesResponseContent,
  GetRunMetricsResponseContent,
  GetRunResponseContent,
  GetStatistics200Response,
  GetTableDataResponseContent,
  GrantItem,
  GrantListResponse,
  ListDataStreamsResponseContent,
  ListDtaApprovals200Response,
  ListIngestionSpecsResponseContent,
  ListInsightsResponseContent,
  ListRunsResponseContent,
  ListTablesResponseContent,
  MarkNotificationsReadBatchRequest,
  MyAccessResponse,
  NotificationSummaryResponse,
  ParseEdcFileRequest,
  ParseSpecResponse,
  PresignDocumentUpload200Response,
  PresignUploadRequest,
  PrincipalDetail,
  PrincipalListResponse,
  PrincipalUpdateRequest,
  Proposal,
  ProposalsListResponse,
  ProtocolUploadResponse,
  ReactivateDtaRequestBody,
  RejectApprovalRequest,
  SignDtaRequest,
  SigningRecord,
  SigningRecordsResponse,
  StudyDtaListResponse,
  StudyProtocol,
  SubmitApprovalRequest,
  TerminologyLibraryResponse,
  TriggerVtmfFilingRequest,
  UpdateCommentRequest,
  UpdateDtaRequest,
  UpdateProposalRequest,
  UpdateProtocolRequest,
  UpdateRunRequestContent,
  UpdateRunResponseContent,
  UpdateVendorRequest,
  UploadDtaFileRequest,
  UploadProtocolFileRequest,
  UploadResponse,
  UploadToDta200Response,
  UploadToDtaRequest,
  Vendor,
  VendorListResponse,
  VendorUser,
  VendorUserListResponse,
  VersionActionResponse,
  VersionComparison,
  VtmfFilingActionResponse,
  VtmfFilingsResponse,
  WorkflowApproval,
  WorkflowDiagram,
  WorkflowStatus,
} from '../models/index';
import {
    ActivateDtaWorkflow201ResponseFromJSON,
    ActivateDtaWorkflow201ResponseToJSON,
    ActivateDtaWorkflowRequestFromJSON,
    ActivateDtaWorkflowRequestToJSON,
    AddVendorUserRequestFromJSON,
    AddVendorUserRequestToJSON,
    ApproveDtaRequestFromJSON,
    ApproveDtaRequestToJSON,
    CapabilitySetFromJSON,
    CapabilitySetToJSON,
    CapabilitySetListResponseFromJSON,
    CapabilitySetListResponseToJSON,
    CapabilitySetRequestFromJSON,
    CapabilitySetRequestToJSON,
    CommentFromJSON,
    CommentToJSON,
    CommentsListResponseFromJSON,
    CommentsListResponseToJSON,
    CreateCommentRequestFromJSON,
    CreateCommentRequestToJSON,
    CreateDTAResponseFromJSON,
    CreateDTAResponseToJSON,
    CreateDtaRequestFromJSON,
    CreateDtaRequestToJSON,
    CreateDtaVersionRequestFromJSON,
    CreateDtaVersionRequestToJSON,
    CreateGrantRequestFromJSON,
    CreateGrantRequestToJSON,
    CreateProposalRequestFromJSON,
    CreateProposalRequestToJSON,
    CreateProtocolRequestFromJSON,
    CreateProtocolRequestToJSON,
    CreateStudyRequestFromJSON,
    CreateStudyRequestToJSON,
    CreateVendorRequestFromJSON,
    CreateVendorRequestToJSON,
    DTADetailsFromJSON,
    DTADetailsToJSON,
    DTAVersionFromJSON,
    DTAVersionToJSON,
    DTAVersionsResponseFromJSON,
    DTAVersionsResponseToJSON,
    DaeNotificationsResponseFromJSON,
    DaeNotificationsResponseToJSON,
    DaeStudiesResponseFromJSON,
    DaeStudiesResponseToJSON,
    DaeStudyDetailResponseFromJSON,
    DaeStudyDetailResponseToJSON,
    DeactivateDtaRequestBodyFromJSON,
    DeactivateDtaRequestBodyToJSON,
    DtaListResponseFromJSON,
    DtaListResponseToJSON,
    DtaStageResponseFromJSON,
    DtaStageResponseToJSON,
    DtaSuggestionsResponseFromJSON,
    DtaSuggestionsResponseToJSON,
    DtaThinkingStepsResponseFromJSON,
    DtaThinkingStepsResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ExportQuarantineDataResponseContentFromJSON,
    ExportQuarantineDataResponseContentToJSON,
    GetIngestionSpecResponseContentFromJSON,
    GetIngestionSpecResponseContentToJSON,
    GetQuarantineDataResponseContentFromJSON,
    GetQuarantineDataResponseContentToJSON,
    GetRecordHistoryResponseContentFromJSON,
    GetRecordHistoryResponseContentToJSON,
    GetRunChangesResponseContentFromJSON,
    GetRunChangesResponseContentToJSON,
    GetRunMetricsResponseContentFromJSON,
    GetRunMetricsResponseContentToJSON,
    GetRunResponseContentFromJSON,
    GetRunResponseContentToJSON,
    GetStatistics200ResponseFromJSON,
    GetStatistics200ResponseToJSON,
    GetTableDataResponseContentFromJSON,
    GetTableDataResponseContentToJSON,
    GrantItemFromJSON,
    GrantItemToJSON,
    GrantListResponseFromJSON,
    GrantListResponseToJSON,
    ListDataStreamsResponseContentFromJSON,
    ListDataStreamsResponseContentToJSON,
    ListDtaApprovals200ResponseFromJSON,
    ListDtaApprovals200ResponseToJSON,
    ListIngestionSpecsResponseContentFromJSON,
    ListIngestionSpecsResponseContentToJSON,
    ListInsightsResponseContentFromJSON,
    ListInsightsResponseContentToJSON,
    ListRunsResponseContentFromJSON,
    ListRunsResponseContentToJSON,
    ListTablesResponseContentFromJSON,
    ListTablesResponseContentToJSON,
    MarkNotificationsReadBatchRequestFromJSON,
    MarkNotificationsReadBatchRequestToJSON,
    MyAccessResponseFromJSON,
    MyAccessResponseToJSON,
    NotificationSummaryResponseFromJSON,
    NotificationSummaryResponseToJSON,
    ParseEdcFileRequestFromJSON,
    ParseEdcFileRequestToJSON,
    ParseSpecResponseFromJSON,
    ParseSpecResponseToJSON,
    PresignDocumentUpload200ResponseFromJSON,
    PresignDocumentUpload200ResponseToJSON,
    PresignUploadRequestFromJSON,
    PresignUploadRequestToJSON,
    PrincipalDetailFromJSON,
    PrincipalDetailToJSON,
    PrincipalListResponseFromJSON,
    PrincipalListResponseToJSON,
    PrincipalUpdateRequestFromJSON,
    PrincipalUpdateRequestToJSON,
    ProposalFromJSON,
    ProposalToJSON,
    ProposalsListResponseFromJSON,
    ProposalsListResponseToJSON,
    ProtocolUploadResponseFromJSON,
    ProtocolUploadResponseToJSON,
    ReactivateDtaRequestBodyFromJSON,
    ReactivateDtaRequestBodyToJSON,
    RejectApprovalRequestFromJSON,
    RejectApprovalRequestToJSON,
    SignDtaRequestFromJSON,
    SignDtaRequestToJSON,
    SigningRecordFromJSON,
    SigningRecordToJSON,
    SigningRecordsResponseFromJSON,
    SigningRecordsResponseToJSON,
    StudyDtaListResponseFromJSON,
    StudyDtaListResponseToJSON,
    StudyProtocolFromJSON,
    StudyProtocolToJSON,
    SubmitApprovalRequestFromJSON,
    SubmitApprovalRequestToJSON,
    TerminologyLibraryResponseFromJSON,
    TerminologyLibraryResponseToJSON,
    TriggerVtmfFilingRequestFromJSON,
    TriggerVtmfFilingRequestToJSON,
    UpdateCommentRequestFromJSON,
    UpdateCommentRequestToJSON,
    UpdateDtaRequestFromJSON,
    UpdateDtaRequestToJSON,
    UpdateProposalRequestFromJSON,
    UpdateProposalRequestToJSON,
    UpdateProtocolRequestFromJSON,
    UpdateProtocolRequestToJSON,
    UpdateRunRequestContentFromJSON,
    UpdateRunRequestContentToJSON,
    UpdateRunResponseContentFromJSON,
    UpdateRunResponseContentToJSON,
    UpdateVendorRequestFromJSON,
    UpdateVendorRequestToJSON,
    UploadDtaFileRequestFromJSON,
    UploadDtaFileRequestToJSON,
    UploadProtocolFileRequestFromJSON,
    UploadProtocolFileRequestToJSON,
    UploadResponseFromJSON,
    UploadResponseToJSON,
    UploadToDta200ResponseFromJSON,
    UploadToDta200ResponseToJSON,
    UploadToDtaRequestFromJSON,
    UploadToDtaRequestToJSON,
    VendorFromJSON,
    VendorToJSON,
    VendorListResponseFromJSON,
    VendorListResponseToJSON,
    VendorUserFromJSON,
    VendorUserToJSON,
    VendorUserListResponseFromJSON,
    VendorUserListResponseToJSON,
    VersionActionResponseFromJSON,
    VersionActionResponseToJSON,
    VersionComparisonFromJSON,
    VersionComparisonToJSON,
    VtmfFilingActionResponseFromJSON,
    VtmfFilingActionResponseToJSON,
    VtmfFilingsResponseFromJSON,
    VtmfFilingsResponseToJSON,
    WorkflowApprovalFromJSON,
    WorkflowApprovalToJSON,
    WorkflowDiagramFromJSON,
    WorkflowDiagramToJSON,
    WorkflowStatusFromJSON,
    WorkflowStatusToJSON,
} from '../models/index';

export interface ActivateDtaVersionRequest {
    dtaId: string;
    version: string;
    body: object;
}

export interface ActivateDtaWorkflowOperationRequest {
    dtaId: string;
    activateDtaWorkflowRequest?: ActivateDtaWorkflowRequest;
}

export interface AddVendorUserOperationRequest {
    vendorId: string;
    addVendorUserRequest: AddVendorUserRequest;
}

export interface ApiV1AuditsDtasDtaIdOptionsRequest {
    dtaId: string;
}

export interface ApiV1AuditsReportsReportIdOptionsRequest {
    reportId: string;
}

export interface ApiV1AuditsStudiesStudyIdOptionsRequest {
    studyId: string;
}

export interface ApiV1AuditsUsersUserIdOptionsRequest {
    userId: string;
}

export interface ApiV1CapabilitySetsCapabilitySetOptionsRequest {
    capabilitySet: string;
}

export interface ApiV1DtasDtaIdApprovalsApprovalIdOptionsRequest {
    dtaId: string;
    approvalId: string;
}

export interface ApiV1DtasDtaIdApprovalsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdCommentsCommentIdOptionsRequest {
    dtaId: string;
    commentId: string;
}

export interface ApiV1DtasDtaIdCommentsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdDeactivateOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdGrantCandidatesOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdGrantsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptionsRequest {
    dtaId: string;
    principalId: string;
    capabilitySet: string;
}

export interface ApiV1DtasDtaIdIngestionSpecOptionsRequest {
    dtaId: string;
    dtaId2: string;
}

export interface ApiV1DtasDtaIdIngestionSpecSyncStatusOptionsRequest {
    dtaId: string;
    dtaId2: string;
}

export interface ApiV1DtasDtaIdOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdProposalsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdProposalsProposalIdOptionsRequest {
    dtaId: string;
    proposalId: string;
}

export interface ApiV1DtasDtaIdReactivateOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdSigningRecordsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdSuggestionsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdThinkingStepsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdUploadOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdVersionsCompareOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdVersionsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdVersionsVersionActivateOptionsRequest {
    dtaId: string;
    version: string;
}

export interface ApiV1DtasDtaIdVersionsVersionDeactivateOptionsRequest {
    dtaId: string;
    version: string;
}

export interface ApiV1DtasDtaIdVersionsVersionOptionsRequest {
    dtaId: string;
    version: string;
}

export interface ApiV1DtasDtaIdVtmfFilingsOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdWorkflowDiagramOptionsRequest {
    dtaId: string;
}

export interface ApiV1DtasDtaIdWorkflowStatusOptionsRequest {
    dtaId: string;
}

export interface ApiV1PrincipalsPrincipalIdOptionsRequest {
    principalId: string;
}

export interface ApiV1StudiesStudyIdDataStreamsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDocumentsPresignOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDtasCreateOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDtasOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDtasParseEdcOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDtasParseSdtmOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdDtasUploadOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdGrantsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptionsRequest {
    studyId: string;
    principalId: string;
    capabilitySet: string;
}

export interface ApiV1StudiesStudyIdIngestionSpecsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdIngestionSpecsSpecIdOptionsRequest {
    studyId: string;
    specId: string;
}

export interface ApiV1StudiesStudyIdInsightsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdProtocolOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdProtocolUploadOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdRunsMetricsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdRunsOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdRunsRunIdChangesOptionsRequest {
    studyId: string;
    runId: string;
}

export interface ApiV1StudiesStudyIdRunsRunIdOptionsRequest {
    studyId: string;
    runId: string;
}

export interface ApiV1StudiesStudyIdRunsRunIdQuarantineDataOptionsRequest {
    studyId: string;
    runId: string;
}

export interface ApiV1StudiesStudyIdRunsRunIdQuarantineExportOptionsRequest {
    studyId: string;
    runId: string;
}

export interface ApiV1StudiesStudyIdTablesOptionsRequest {
    studyId: string;
}

export interface ApiV1StudiesStudyIdTablesTableNameDataOptionsRequest {
    studyId: string;
    tableName: string;
}

export interface ApiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptionsRequest {
    studyId: string;
    tableName: string;
    primaryKeyValue: string;
}

export interface ApiV1TerminologyLibraryCodeOptionsRequest {
    code: string;
}

export interface ApiV1VendorsVendorIdOptionsRequest {
    vendorId: string;
}

export interface ApiV1VendorsVendorIdUsersOptionsRequest {
    vendorId: string;
}

export interface ApiV1VendorsVendorIdUsersPrincipalIdOptionsRequest {
    vendorId: string;
    principalId: string;
}

export interface ApproveDtaOperationRequest {
    dtaId: string;
    approveDtaRequest?: ApproveDtaRequest;
}

export interface CompareVersionsRequest {
    baseVersion: string;
    compareVersion: string;
    dtaId: string;
}

export interface CreateCapabilitySetRequest {
    capabilitySetRequest: CapabilitySetRequest;
}

export interface CreateCommentOperationRequest {
    dtaId: string;
    createCommentRequest: CreateCommentRequest;
}

export interface CreateDtaOperationRequest {
    studyId: string;
    createDtaRequest: CreateDtaRequest;
}

export interface CreateDtaGrantRequest {
    dtaId: string;
    createGrantRequest: CreateGrantRequest;
}

export interface CreateDtaVersionOperationRequest {
    dtaId: string;
    createDtaVersionRequest: CreateDtaVersionRequest;
}

export interface CreateProposalOperationRequest {
    dtaId: string;
    createProposalRequest: CreateProposalRequest;
}

export interface CreateStudyOperationRequest {
    createStudyRequest: CreateStudyRequest;
}

export interface CreateStudyGrantRequest {
    studyId: string;
    createGrantRequest: CreateGrantRequest;
}

export interface CreateVendorOperationRequest {
    createVendorRequest: CreateVendorRequest;
}

export interface DeactivateDtaRequest {
    dtaId: string;
    deactivateDtaRequestBody: DeactivateDtaRequestBody;
}

export interface DeactivateDtaVersionRequest {
    dtaId: string;
    version: string;
    body: object;
}

export interface ExportStudyRunQuarantineDataRequest {
    studyId: string;
    runId: string;
}

export interface GetAuditDtaStatusRequest {
    dtaId: string;
    days?: number;
}

export interface GetAuditReportRequest {
    reportId: string;
}

export interface GetAuditVendorActivityRequest {
    vendorEmail: string;
    days?: number;
}

export interface GetCapabilitySetRequest {
    capabilitySet: string;
}

export interface GetDTAAuditTrailRequest {
    dtaId: string;
}

export interface GetDaeStudyDetailRequest {
    studyId: string;
}

export interface GetDtaDetailRequest {
    dtaId: string;
    version?: string;
}

export interface GetDtaIngestionSpecRequest {
    dtaId: string;
    dtaId2: string;
}

export interface GetDtaSigningRecordsRequest {
    dtaId: string;
}

export interface GetDtaSuggestionsRequest {
    dtaId: string;
}

export interface GetDtaThinkingStepsRequest {
    dtaId: string;
}

export interface GetDtaVersionRequest {
    dtaId: string;
    version: string;
}

export interface GetDtaVtmfFilingsRequest {
    dtaId: string;
}

export interface GetDtaWorkflowStatusRequest {
    dtaId: string;
}

export interface GetNotificationSummaryRequest {
    includeTotal?: boolean;
}

export interface GetPrincipalRequest {
    principalId: string;
}

export interface GetProtocolRequest {
    studyId: string;
}

export interface GetRecordHistoryRequest {
    studyId: string;
    tableName: string;
    primaryKeyValue: string;
}

export interface GetStudyIngestionSpecRequest {
    studyId: string;
    specId: string;
}

export interface GetStudyRunRequest {
    studyId: string;
    runId: string;
}

export interface GetStudyRunChangesRequest {
    studyId: string;
    runId: string;
}

export interface GetStudyRunMetricsRequest {
    studyId: string;
}

export interface GetStudyRunQuarantineDataRequest {
    studyId: string;
    runId: string;
    pageSize?: number;
    nextToken?: string;
}

export interface GetStudyTableDataRequest {
    studyId: string;
    tableName: string;
    pageSize?: number;
    nextToken?: string;
}

export interface GetTerminologyByCodeRequest {
    code: string;
}

export interface GetVendorRequest {
    vendorId: string;
}

export interface GetWorkflowDiagramRequest {
    dtaId: string;
}

export interface ListAllDtasRequest {
    limit?: number;
    nextToken?: string;
    status?: string;
}

export interface ListCapabilitySetsRequest {
    limit?: number;
    nextToken?: string;
}

export interface ListDaeNotificationsRequest {
    limit?: number;
    nextToken?: string;
}

export interface ListDaeStudiesRequest {
    limit?: number;
    nextToken?: string;
}

export interface ListDtaApprovalsRequest {
    dtaId: string;
    stage?: string;
    status?: string;
}

export interface ListDtaCommentsRequest {
    dtaId: string;
    section?: string;
    version?: string;
}

export interface ListDtaGrantCandidatesRequest {
    dtaId: string;
    limit?: number;
    nextToken?: string;
}

export interface ListDtaGrantsRequest {
    dtaId: string;
    limit?: number;
    nextToken?: string;
}

export interface ListDtaProposalsRequest {
    dtaId: string;
    section?: string;
    status?: string;
    version?: string;
}

export interface ListDtaVersionsRequest {
    dtaId: string;
    limit?: number;
}

export interface ListPrincipalsRequest {
    limit?: number;
    nextToken?: string;
}

export interface ListStudyAuditEventsRequest {
    studyId: string;
}

export interface ListStudyDataStreamsRequest {
    studyId: string;
}

export interface ListStudyDtasRequest {
    studyId: string;
    status?: string;
    vendor?: string;
    domain?: string;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: string;
    nextToken?: string;
}

export interface ListStudyGrantsRequest {
    studyId: string;
    limit?: number;
    nextToken?: string;
}

export interface ListStudyIngestionSpecsRequest {
    studyId: string;
}

export interface ListStudyInsightsRequest {
    studyId: string;
    nextToken?: string;
}

export interface ListStudyRunsRequest {
    studyId: string;
    specId?: string;
    pageSize?: number;
    nextToken?: string;
}

export interface ListStudyTablesRequest {
    studyId: string;
}

export interface ListUserAuditEventsRequest {
    userId: string;
}

export interface ListVendorUsersRequest {
    vendorId: string;
    limit?: number;
    nextToken?: string;
}

export interface ListVendorsRequest {
    limit?: number;
    nextToken?: string;
}

export interface MarkNotificationsReadBatchOperationRequest {
    markNotificationsReadBatchRequest: MarkNotificationsReadBatchRequest;
}

export interface ParseEdcFileOperationRequest {
    studyId: string;
    parseEdcFileRequest: ParseEdcFileRequest;
}

export interface ParseSdtmFileRequest {
    studyId: string;
    parseEdcFileRequest: ParseEdcFileRequest;
}

export interface PostProtocolRequest {
    studyId: string;
    createProtocolRequest: CreateProtocolRequest;
}

export interface PresignDocumentUploadRequest {
    studyId: string;
    presignUploadRequest: PresignUploadRequest;
}

export interface PublishDtaRequest {
    dtaId: string;
    activateDtaWorkflowRequest?: ActivateDtaWorkflowRequest;
}

export interface PutProtocolRequest {
    studyId: string;
    updateProtocolRequest: UpdateProtocolRequest;
}

export interface ReactivateDtaRequest {
    dtaId: string;
    reactivateDtaRequestBody: ReactivateDtaRequestBody;
}

export interface RejectApprovalOperationRequest {
    dtaId: string;
    approvalId: string;
    rejectApprovalRequest: RejectApprovalRequest;
}

export interface RemoveVendorUserRequest {
    vendorId: string;
    principalId: string;
}

export interface RevokeDtaGrantRequest {
    dtaId: string;
    principalId: string;
    capabilitySet: string;
}

export interface RevokeStudyGrantRequest {
    studyId: string;
    principalId: string;
    capabilitySet: string;
}

export interface SignDtaOperationRequest {
    dtaId: string;
    signDtaRequest: SignDtaRequest;
}

export interface SubmitApprovalOperationRequest {
    dtaId: string;
    submitApprovalRequest: SubmitApprovalRequest;
}

export interface SyncIngestionSpecStatusRequest {
    dtaId: string;
    dtaId2: string;
}

export interface TriggerDtaVtmfFilingRequest {
    dtaId: string;
    triggerVtmfFilingRequest: TriggerVtmfFilingRequest;
}

export interface UpdateCapabilitySetRequest {
    capabilitySet: string;
    capabilitySetRequest: CapabilitySetRequest;
}

export interface UpdateCommentOperationRequest {
    dtaId: string;
    commentId: string;
    updateCommentRequest: UpdateCommentRequest;
}

export interface UpdateDtaOperationRequest {
    dtaId: string;
    updateDtaRequest: UpdateDtaRequest;
}

export interface UpdatePrincipalRequest {
    principalId: string;
    principalUpdateRequest: PrincipalUpdateRequest;
}

export interface UpdateProposalOperationRequest {
    dtaId: string;
    proposalId: string;
    updateProposalRequest: UpdateProposalRequest;
}

export interface UpdateStudyRunRequest {
    studyId: string;
    runId: string;
    updateRunRequestContent: UpdateRunRequestContent;
}

export interface UpdateVendorOperationRequest {
    vendorId: string;
    updateVendorRequest: UpdateVendorRequest;
}

export interface UploadDtaFileOperationRequest {
    studyId: string;
    uploadDtaFileRequest: UploadDtaFileRequest;
}

export interface UploadProtocolRequest {
    studyId: string;
    uploadProtocolFileRequest: UploadProtocolFileRequest;
}

export interface UploadToDtaOperationRequest {
    dtaId: string;
    uploadToDtaRequest: UploadToDtaRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async activateDtaVersionRaw(requestParameters: ActivateDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VersionActionResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling activateDtaVersion().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling activateDtaVersion().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling activateDtaVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}/activate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionActionResponseFromJSON(jsonValue));
    }

    /**
     */
    async activateDtaVersion(requestParameters: ActivateDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VersionActionResponse> {
        const response = await this.activateDtaVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activate DTA (APPROVED -> ACTIVE)
     */
    async activateDtaWorkflowRaw(requestParameters: ActivateDtaWorkflowOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivateDtaWorkflow201Response>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling activateDtaWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/activate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateDtaWorkflowRequestToJSON(requestParameters['activateDtaWorkflowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivateDtaWorkflow201ResponseFromJSON(jsonValue));
    }

    /**
     * Activate DTA (APPROVED -> ACTIVE)
     */
    async activateDtaWorkflow(requestParameters: ActivateDtaWorkflowOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivateDtaWorkflow201Response> {
        const response = await this.activateDtaWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a person to a vendor company by email, creating their principal if CDR has none
     */
    async addVendorUserRaw(requestParameters: AddVendorUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorUser>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling addVendorUser().'
            );
        }

        if (requestParameters['addVendorUserRequest'] == null) {
            throw new runtime.RequiredError(
                'addVendorUserRequest',
                'Required parameter "addVendorUserRequest" was null or undefined when calling addVendorUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}/users`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddVendorUserRequestToJSON(requestParameters['addVendorUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorUserFromJSON(jsonValue));
    }

    /**
     * Add a person to a vendor company by email, creating their principal if CDR has none
     */
    async addVendorUser(requestParameters: AddVendorUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorUser> {
        const response = await this.addVendorUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CORS preflight
     */
    async apiV1AuditActivityOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/activity`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditActivityOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditActivityOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditDtaStatusOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/dta-status`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditDtaStatusOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditDtaStatusOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSearchOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/search`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSearchOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditSearchOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSecurityOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/security`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSecurityOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditSecurityOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSummaryOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/summary`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSummaryOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditSummaryOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSystemReportOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/system-report`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditSystemReportOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditSystemReportOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditVendorActivityOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/vendor-activity`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditVendorActivityOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditVendorActivityOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsDtasDtaIdOptionsRaw(requestParameters: ApiV1AuditsDtasDtaIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1AuditsDtasDtaIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/dtas/{dtaId}`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsDtasDtaIdOptions(requestParameters: ApiV1AuditsDtasDtaIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditsDtasDtaIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsReportsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/reports`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsReportsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditsReportsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsReportsReportIdOptionsRaw(requestParameters: ApiV1AuditsReportsReportIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling apiV1AuditsReportsReportIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/reports/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsReportsReportIdOptions(requestParameters: ApiV1AuditsReportsReportIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditsReportsReportIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsStudiesStudyIdOptionsRaw(requestParameters: ApiV1AuditsStudiesStudyIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1AuditsStudiesStudyIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/studies/{studyId}`.replace(`{${"studyId"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsStudiesStudyIdOptions(requestParameters: ApiV1AuditsStudiesStudyIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditsStudiesStudyIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsUsersUserIdOptionsRaw(requestParameters: ApiV1AuditsUsersUserIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiV1AuditsUsersUserIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1AuditsUsersUserIdOptions(requestParameters: ApiV1AuditsUsersUserIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1AuditsUsersUserIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1CapabilitySetsCapabilitySetOptionsRaw(requestParameters: ApiV1CapabilitySetsCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling apiV1CapabilitySetsCapabilitySetOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/capability-sets/{capability_set}`.replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1CapabilitySetsCapabilitySetOptions(requestParameters: ApiV1CapabilitySetsCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1CapabilitySetsCapabilitySetOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1CapabilitySetsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/capability-sets`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1CapabilitySetsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1CapabilitySetsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdApprovalsApprovalIdOptionsRaw(requestParameters: ApiV1DtasDtaIdApprovalsApprovalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdApprovalsApprovalIdOptions().'
            );
        }

        if (requestParameters['approvalId'] == null) {
            throw new runtime.RequiredError(
                'approvalId',
                'Required parameter "approvalId" was null or undefined when calling apiV1DtasDtaIdApprovalsApprovalIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approvals/{approval_id}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"approval_id"}}`, encodeURIComponent(String(requestParameters['approvalId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdApprovalsApprovalIdOptions(requestParameters: ApiV1DtasDtaIdApprovalsApprovalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdApprovalsApprovalIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdApprovalsOptionsRaw(requestParameters: ApiV1DtasDtaIdApprovalsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdApprovalsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approvals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdApprovalsOptions(requestParameters: ApiV1DtasDtaIdApprovalsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdApprovalsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdCommentsCommentIdOptionsRaw(requestParameters: ApiV1DtasDtaIdCommentsCommentIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdCommentsCommentIdOptions().'
            );
        }

        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError(
                'commentId',
                'Required parameter "commentId" was null or undefined when calling apiV1DtasDtaIdCommentsCommentIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/comments/{commentId}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdCommentsCommentIdOptions(requestParameters: ApiV1DtasDtaIdCommentsCommentIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdCommentsCommentIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdCommentsOptionsRaw(requestParameters: ApiV1DtasDtaIdCommentsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdCommentsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/comments`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdCommentsOptions(requestParameters: ApiV1DtasDtaIdCommentsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdCommentsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdDeactivateOptionsRaw(requestParameters: ApiV1DtasDtaIdDeactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdDeactivateOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/deactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdDeactivateOptions(requestParameters: ApiV1DtasDtaIdDeactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdDeactivateOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantCandidatesOptionsRaw(requestParameters: ApiV1DtasDtaIdGrantCandidatesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdGrantCandidatesOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grant-candidates`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantCandidatesOptions(requestParameters: ApiV1DtasDtaIdGrantCandidatesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdGrantCandidatesOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantsOptionsRaw(requestParameters: ApiV1DtasDtaIdGrantsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdGrantsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grants`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantsOptions(requestParameters: ApiV1DtasDtaIdGrantsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdGrantsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptionsRaw(requestParameters: ApiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grants/{principal_id}/{capability_set}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"principal_id"}}`, encodeURIComponent(String(requestParameters['principalId']))).replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptions(requestParameters: ApiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdGrantsPrincipalIdCapabilitySetOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdIngestionSpecOptionsRaw(requestParameters: ApiV1DtasDtaIdIngestionSpecOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdIngestionSpecOptions().'
            );
        }

        if (requestParameters['dtaId2'] == null) {
            throw new runtime.RequiredError(
                'dtaId2',
                'Required parameter "dtaId2" was null or undefined when calling apiV1DtasDtaIdIngestionSpecOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/ingestion-spec`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId2']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdIngestionSpecOptions(requestParameters: ApiV1DtasDtaIdIngestionSpecOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdIngestionSpecOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdIngestionSpecSyncStatusOptionsRaw(requestParameters: ApiV1DtasDtaIdIngestionSpecSyncStatusOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdIngestionSpecSyncStatusOptions().'
            );
        }

        if (requestParameters['dtaId2'] == null) {
            throw new runtime.RequiredError(
                'dtaId2',
                'Required parameter "dtaId2" was null or undefined when calling apiV1DtasDtaIdIngestionSpecSyncStatusOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/ingestion-spec/sync-status`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId2']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdIngestionSpecSyncStatusOptions(requestParameters: ApiV1DtasDtaIdIngestionSpecSyncStatusOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdIngestionSpecSyncStatusOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdOptionsRaw(requestParameters: ApiV1DtasDtaIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdOptions(requestParameters: ApiV1DtasDtaIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdProposalsOptionsRaw(requestParameters: ApiV1DtasDtaIdProposalsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdProposalsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/proposals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdProposalsOptions(requestParameters: ApiV1DtasDtaIdProposalsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdProposalsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdProposalsProposalIdOptionsRaw(requestParameters: ApiV1DtasDtaIdProposalsProposalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdProposalsProposalIdOptions().'
            );
        }

        if (requestParameters['proposalId'] == null) {
            throw new runtime.RequiredError(
                'proposalId',
                'Required parameter "proposalId" was null or undefined when calling apiV1DtasDtaIdProposalsProposalIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/proposals/{proposalId}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters['proposalId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdProposalsProposalIdOptions(requestParameters: ApiV1DtasDtaIdProposalsProposalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdProposalsProposalIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdReactivateOptionsRaw(requestParameters: ApiV1DtasDtaIdReactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdReactivateOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/reactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdReactivateOptions(requestParameters: ApiV1DtasDtaIdReactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdReactivateOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdSigningRecordsOptionsRaw(requestParameters: ApiV1DtasDtaIdSigningRecordsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdSigningRecordsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/signing-records`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdSigningRecordsOptions(requestParameters: ApiV1DtasDtaIdSigningRecordsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdSigningRecordsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdSuggestionsOptionsRaw(requestParameters: ApiV1DtasDtaIdSuggestionsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdSuggestionsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/suggestions`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdSuggestionsOptions(requestParameters: ApiV1DtasDtaIdSuggestionsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdSuggestionsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdThinkingStepsOptionsRaw(requestParameters: ApiV1DtasDtaIdThinkingStepsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdThinkingStepsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/thinking-steps`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdThinkingStepsOptions(requestParameters: ApiV1DtasDtaIdThinkingStepsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdThinkingStepsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdUploadOptionsRaw(requestParameters: ApiV1DtasDtaIdUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdUploadOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/upload`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdUploadOptions(requestParameters: ApiV1DtasDtaIdUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdUploadOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsCompareOptionsRaw(requestParameters: ApiV1DtasDtaIdVersionsCompareOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVersionsCompareOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/compare`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsCompareOptions(requestParameters: ApiV1DtasDtaIdVersionsCompareOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVersionsCompareOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsOptionsRaw(requestParameters: ApiV1DtasDtaIdVersionsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVersionsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsOptions(requestParameters: ApiV1DtasDtaIdVersionsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVersionsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionActivateOptionsRaw(requestParameters: ApiV1DtasDtaIdVersionsVersionActivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVersionsVersionActivateOptions().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling apiV1DtasDtaIdVersionsVersionActivateOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}/activate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionActivateOptions(requestParameters: ApiV1DtasDtaIdVersionsVersionActivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVersionsVersionActivateOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionDeactivateOptionsRaw(requestParameters: ApiV1DtasDtaIdVersionsVersionDeactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVersionsVersionDeactivateOptions().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling apiV1DtasDtaIdVersionsVersionDeactivateOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}/deactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionDeactivateOptions(requestParameters: ApiV1DtasDtaIdVersionsVersionDeactivateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVersionsVersionDeactivateOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionOptionsRaw(requestParameters: ApiV1DtasDtaIdVersionsVersionOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVersionsVersionOptions().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling apiV1DtasDtaIdVersionsVersionOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVersionsVersionOptions(requestParameters: ApiV1DtasDtaIdVersionsVersionOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVersionsVersionOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVtmfFilingsOptionsRaw(requestParameters: ApiV1DtasDtaIdVtmfFilingsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdVtmfFilingsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/vtmf/filings`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdVtmfFilingsOptions(requestParameters: ApiV1DtasDtaIdVtmfFilingsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdVtmfFilingsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdWorkflowDiagramOptionsRaw(requestParameters: ApiV1DtasDtaIdWorkflowDiagramOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdWorkflowDiagramOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/workflow-diagram`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdWorkflowDiagramOptions(requestParameters: ApiV1DtasDtaIdWorkflowDiagramOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdWorkflowDiagramOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdWorkflowStatusOptionsRaw(requestParameters: ApiV1DtasDtaIdWorkflowStatusOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling apiV1DtasDtaIdWorkflowStatusOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/workflow-status`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasDtaIdWorkflowStatusOptions(requestParameters: ApiV1DtasDtaIdWorkflowStatusOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasDtaIdWorkflowStatusOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1DtasOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1DtasOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1HealthOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/health`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1HealthOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1HealthOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1IngestionSpecsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/ingestion-specs`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1IngestionSpecsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1IngestionSpecsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1MeOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/me`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1MeOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1MeOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/notifications`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1NotificationsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsReadOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/notifications/read`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsReadOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1NotificationsReadOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsSummaryOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/notifications/summary`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1NotificationsSummaryOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1NotificationsSummaryOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1PrincipalsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/principals`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1PrincipalsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1PrincipalsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1PrincipalsPrincipalIdOptionsRaw(requestParameters: ApiV1PrincipalsPrincipalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling apiV1PrincipalsPrincipalIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/principals/{principalId}`.replace(`{${"principalId"}}`, encodeURIComponent(String(requestParameters['principalId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1PrincipalsPrincipalIdOptions(requestParameters: ApiV1PrincipalsPrincipalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1PrincipalsPrincipalIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StatisticsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/statistics`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StatisticsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StatisticsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDataStreamsOptionsRaw(requestParameters: ApiV1StudiesStudyIdDataStreamsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDataStreamsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/data-streams`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDataStreamsOptions(requestParameters: ApiV1StudiesStudyIdDataStreamsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDataStreamsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDocumentsPresignOptionsRaw(requestParameters: ApiV1StudiesStudyIdDocumentsPresignOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDocumentsPresignOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/documents/presign`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDocumentsPresignOptions(requestParameters: ApiV1StudiesStudyIdDocumentsPresignOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDocumentsPresignOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasCreateOptionsRaw(requestParameters: ApiV1StudiesStudyIdDtasCreateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDtasCreateOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/create`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasCreateOptions(requestParameters: ApiV1StudiesStudyIdDtasCreateOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDtasCreateOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasOptionsRaw(requestParameters: ApiV1StudiesStudyIdDtasOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDtasOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasOptions(requestParameters: ApiV1StudiesStudyIdDtasOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDtasOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasParseEdcOptionsRaw(requestParameters: ApiV1StudiesStudyIdDtasParseEdcOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDtasParseEdcOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/parse-edc`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasParseEdcOptions(requestParameters: ApiV1StudiesStudyIdDtasParseEdcOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDtasParseEdcOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasParseSdtmOptionsRaw(requestParameters: ApiV1StudiesStudyIdDtasParseSdtmOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDtasParseSdtmOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/parse-sdtm`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasParseSdtmOptions(requestParameters: ApiV1StudiesStudyIdDtasParseSdtmOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDtasParseSdtmOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasUploadOptionsRaw(requestParameters: ApiV1StudiesStudyIdDtasUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdDtasUploadOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/upload`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdDtasUploadOptions(requestParameters: ApiV1StudiesStudyIdDtasUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdDtasUploadOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdGrantsOptionsRaw(requestParameters: ApiV1StudiesStudyIdGrantsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdGrantsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/grants`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdGrantsOptions(requestParameters: ApiV1StudiesStudyIdGrantsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdGrantsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptionsRaw(requestParameters: ApiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/grants/{principal_id}/{capability_set}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"principal_id"}}`, encodeURIComponent(String(requestParameters['principalId']))).replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptions(requestParameters: ApiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdGrantsPrincipalIdCapabilitySetOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdIngestionSpecsOptionsRaw(requestParameters: ApiV1StudiesStudyIdIngestionSpecsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdIngestionSpecsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/ingestion-specs`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdIngestionSpecsOptions(requestParameters: ApiV1StudiesStudyIdIngestionSpecsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdIngestionSpecsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdIngestionSpecsSpecIdOptionsRaw(requestParameters: ApiV1StudiesStudyIdIngestionSpecsSpecIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdIngestionSpecsSpecIdOptions().'
            );
        }

        if (requestParameters['specId'] == null) {
            throw new runtime.RequiredError(
                'specId',
                'Required parameter "specId" was null or undefined when calling apiV1StudiesStudyIdIngestionSpecsSpecIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/ingestion-specs/{spec_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"spec_id"}}`, encodeURIComponent(String(requestParameters['specId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdIngestionSpecsSpecIdOptions(requestParameters: ApiV1StudiesStudyIdIngestionSpecsSpecIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdIngestionSpecsSpecIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdInsightsOptionsRaw(requestParameters: ApiV1StudiesStudyIdInsightsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdInsightsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/insights`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdInsightsOptions(requestParameters: ApiV1StudiesStudyIdInsightsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdInsightsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdOptionsRaw(requestParameters: ApiV1StudiesStudyIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdOptions(requestParameters: ApiV1StudiesStudyIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdProtocolOptionsRaw(requestParameters: ApiV1StudiesStudyIdProtocolOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdProtocolOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdProtocolOptions(requestParameters: ApiV1StudiesStudyIdProtocolOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdProtocolOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdProtocolUploadOptionsRaw(requestParameters: ApiV1StudiesStudyIdProtocolUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdProtocolUploadOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol/upload`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdProtocolUploadOptions(requestParameters: ApiV1StudiesStudyIdProtocolUploadOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdProtocolUploadOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsMetricsOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsMetricsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsMetricsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/metrics`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsMetricsOptions(requestParameters: ApiV1StudiesStudyIdRunsMetricsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsMetricsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsOptions(requestParameters: ApiV1StudiesStudyIdRunsOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdChangesOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsRunIdChangesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdChangesOptions().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdChangesOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/changes`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdChangesOptions(requestParameters: ApiV1StudiesStudyIdRunsRunIdChangesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsRunIdChangesOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsRunIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdOptions().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdOptions(requestParameters: ApiV1StudiesStudyIdRunsRunIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsRunIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdQuarantineDataOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsRunIdQuarantineDataOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdQuarantineDataOptions().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdQuarantineDataOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/quarantine-data`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdQuarantineDataOptions(requestParameters: ApiV1StudiesStudyIdRunsRunIdQuarantineDataOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsRunIdQuarantineDataOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdQuarantineExportOptionsRaw(requestParameters: ApiV1StudiesStudyIdRunsRunIdQuarantineExportOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdQuarantineExportOptions().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling apiV1StudiesStudyIdRunsRunIdQuarantineExportOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/quarantine-export`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdRunsRunIdQuarantineExportOptions(requestParameters: ApiV1StudiesStudyIdRunsRunIdQuarantineExportOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdRunsRunIdQuarantineExportOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesOptionsRaw(requestParameters: ApiV1StudiesStudyIdTablesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdTablesOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesOptions(requestParameters: ApiV1StudiesStudyIdTablesOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdTablesOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesTableNameDataOptionsRaw(requestParameters: ApiV1StudiesStudyIdTablesTableNameDataOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdTablesTableNameDataOptions().'
            );
        }

        if (requestParameters['tableName'] == null) {
            throw new runtime.RequiredError(
                'tableName',
                'Required parameter "tableName" was null or undefined when calling apiV1StudiesStudyIdTablesTableNameDataOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables/{table_name}/data`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"table_name"}}`, encodeURIComponent(String(requestParameters['tableName']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesTableNameDataOptions(requestParameters: ApiV1StudiesStudyIdTablesTableNameDataOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdTablesTableNameDataOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptionsRaw(requestParameters: ApiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptions().'
            );
        }

        if (requestParameters['tableName'] == null) {
            throw new runtime.RequiredError(
                'tableName',
                'Required parameter "tableName" was null or undefined when calling apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptions().'
            );
        }

        if (requestParameters['primaryKeyValue'] == null) {
            throw new runtime.RequiredError(
                'primaryKeyValue',
                'Required parameter "primaryKeyValue" was null or undefined when calling apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables/{table_name}/records/{primary_key_value}/history`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"table_name"}}`, encodeURIComponent(String(requestParameters['tableName']))).replace(`{${"primary_key_value"}}`, encodeURIComponent(String(requestParameters['primaryKeyValue']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptions(requestParameters: ApiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1StudiesStudyIdTablesTableNameRecordsPrimaryKeyValueHistoryOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1TerminologyLibraryCodeOptionsRaw(requestParameters: ApiV1TerminologyLibraryCodeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling apiV1TerminologyLibraryCodeOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/terminology-library/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1TerminologyLibraryCodeOptions(requestParameters: ApiV1TerminologyLibraryCodeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1TerminologyLibraryCodeOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1TerminologyLibraryOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/terminology-library`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1TerminologyLibraryOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1TerminologyLibraryOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors`,
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1VendorsOptionsRaw(initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdOptionsRaw(requestParameters: ApiV1VendorsVendorIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling apiV1VendorsVendorIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdOptions(requestParameters: ApiV1VendorsVendorIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1VendorsVendorIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdUsersOptionsRaw(requestParameters: ApiV1VendorsVendorIdUsersOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling apiV1VendorsVendorIdUsersOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}/users`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdUsersOptions(requestParameters: ApiV1VendorsVendorIdUsersOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1VendorsVendorIdUsersOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdUsersPrincipalIdOptionsRaw(requestParameters: ApiV1VendorsVendorIdUsersPrincipalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling apiV1VendorsVendorIdUsersPrincipalIdOptions().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling apiV1VendorsVendorIdUsersPrincipalIdOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}/users/{principalId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))).replace(`{${"principalId"}}`, encodeURIComponent(String(requestParameters['principalId']))),
            method: 'OPTIONS',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CORS preflight
     */
    async apiV1VendorsVendorIdUsersPrincipalIdOptions(requestParameters: ApiV1VendorsVendorIdUsersPrincipalIdOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiV1VendorsVendorIdUsersPrincipalIdOptionsRaw(requestParameters, initOverrides);
    }

    /**
     * Approve DTA (REVIEW -> APPROVED)
     */
    async approveDtaRaw(requestParameters: ApproveDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivateDtaWorkflow201Response>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling approveDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approve`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveDtaRequestToJSON(requestParameters['approveDtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivateDtaWorkflow201ResponseFromJSON(jsonValue));
    }

    /**
     * Approve DTA (REVIEW -> APPROVED)
     */
    async approveDta(requestParameters: ApproveDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivateDtaWorkflow201Response> {
        const response = await this.approveDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async compareVersionsRaw(requestParameters: CompareVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VersionComparison>> {
        if (requestParameters['baseVersion'] == null) {
            throw new runtime.RequiredError(
                'baseVersion',
                'Required parameter "baseVersion" was null or undefined when calling compareVersions().'
            );
        }

        if (requestParameters['compareVersion'] == null) {
            throw new runtime.RequiredError(
                'compareVersion',
                'Required parameter "compareVersion" was null or undefined when calling compareVersions().'
            );
        }

        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling compareVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['baseVersion'] != null) {
            queryParameters['base_version'] = requestParameters['baseVersion'];
        }

        if (requestParameters['compareVersion'] != null) {
            queryParameters['compare_version'] = requestParameters['compareVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/compare`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionComparisonFromJSON(jsonValue));
    }

    /**
     */
    async compareVersions(requestParameters: CompareVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VersionComparison> {
        const response = await this.compareVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createAuditReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createAuditReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createAuditReportRaw(initOverrides);
    }

    /**
     * Needs manage_capability_sets, and is refused unless the deployment turns capability-set editing on.
     * Create an admin-owned capability set
     */
    async createCapabilitySetRaw(requestParameters: CreateCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapabilitySet>> {
        if (requestParameters['capabilitySetRequest'] == null) {
            throw new runtime.RequiredError(
                'capabilitySetRequest',
                'Required parameter "capabilitySetRequest" was null or undefined when calling createCapabilitySet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/capability-sets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CapabilitySetRequestToJSON(requestParameters['capabilitySetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapabilitySetFromJSON(jsonValue));
    }

    /**
     * Needs manage_capability_sets, and is refused unless the deployment turns capability-set editing on.
     * Create an admin-owned capability set
     */
    async createCapabilitySet(requestParameters: CreateCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapabilitySet> {
        const response = await this.createCapabilitySetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCommentRaw(requestParameters: CreateCommentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comment>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling createComment().'
            );
        }

        if (requestParameters['createCommentRequest'] == null) {
            throw new runtime.RequiredError(
                'createCommentRequest',
                'Required parameter "createCommentRequest" was null or undefined when calling createComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/comments`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCommentRequestToJSON(requestParameters['createCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommentFromJSON(jsonValue));
    }

    /**
     */
    async createComment(requestParameters: CreateCommentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comment> {
        const response = await this.createCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createDtaRaw(requestParameters: CreateDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDTAResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling createDta().'
            );
        }

        if (requestParameters['createDtaRequest'] == null) {
            throw new runtime.RequiredError(
                'createDtaRequest',
                'Required parameter "createDtaRequest" was null or undefined when calling createDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/create`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDtaRequestToJSON(requestParameters['createDtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDTAResponseFromJSON(jsonValue));
    }

    /**
     */
    async createDta(requestParameters: CreateDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDTAResponse> {
        const response = await this.createDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grant by email: a person CDR has not seen yet gets a pending principal, and the grant applies at their first sign-in. Returns 201 for a new grant and 200 when the person already holds that set here. Needs manage_assignments on the target. A DTA accepts internal sets, plus vendor sets when it has a vendor.
     * Grant a person a capability set on a DTA
     */
    async createDtaGrantRaw(requestParameters: CreateDtaGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantItem>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling createDtaGrant().'
            );
        }

        if (requestParameters['createGrantRequest'] == null) {
            throw new runtime.RequiredError(
                'createGrantRequest',
                'Required parameter "createGrantRequest" was null or undefined when calling createDtaGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grants`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGrantRequestToJSON(requestParameters['createGrantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrantItemFromJSON(jsonValue));
    }

    /**
     * Grant by email: a person CDR has not seen yet gets a pending principal, and the grant applies at their first sign-in. Returns 201 for a new grant and 200 when the person already holds that set here. Needs manage_assignments on the target. A DTA accepts internal sets, plus vendor sets when it has a vendor.
     * Grant a person a capability set on a DTA
     */
    async createDtaGrant(requestParameters: CreateDtaGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantItem> {
        const response = await this.createDtaGrantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createDtaVersionRaw(requestParameters: CreateDtaVersionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DTAVersion>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling createDtaVersion().'
            );
        }

        if (requestParameters['createDtaVersionRequest'] == null) {
            throw new runtime.RequiredError(
                'createDtaVersionRequest',
                'Required parameter "createDtaVersionRequest" was null or undefined when calling createDtaVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDtaVersionRequestToJSON(requestParameters['createDtaVersionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DTAVersionFromJSON(jsonValue));
    }

    /**
     */
    async createDtaVersion(requestParameters: CreateDtaVersionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DTAVersion> {
        const response = await this.createDtaVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createProposalRaw(requestParameters: CreateProposalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Proposal>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling createProposal().'
            );
        }

        if (requestParameters['createProposalRequest'] == null) {
            throw new runtime.RequiredError(
                'createProposalRequest',
                'Required parameter "createProposalRequest" was null or undefined when calling createProposal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/proposals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProposalRequestToJSON(requestParameters['createProposalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProposalFromJSON(jsonValue));
    }

    /**
     */
    async createProposal(requestParameters: CreateProposalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Proposal> {
        const response = await this.createProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a study
     */
    async createStudyRaw(requestParameters: CreateStudyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createStudyRequest'] == null) {
            throw new runtime.RequiredError(
                'createStudyRequest',
                'Required parameter "createStudyRequest" was null or undefined when calling createStudy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateStudyRequestToJSON(requestParameters['createStudyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a study
     */
    async createStudy(requestParameters: CreateStudyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createStudyRaw(requestParameters, initOverrides);
    }

    /**
     * Grant by email: a person CDR has not seen yet gets a pending principal, and the grant applies at their first sign-in. Returns 201 for a new grant and 200 when the person already holds that set here. Needs manage_assignments on the target. A study accepts internal sets only; its grants cover every DTA in the study.
     * Grant a person a capability set on a study
     */
    async createStudyGrantRaw(requestParameters: CreateStudyGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantItem>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling createStudyGrant().'
            );
        }

        if (requestParameters['createGrantRequest'] == null) {
            throw new runtime.RequiredError(
                'createGrantRequest',
                'Required parameter "createGrantRequest" was null or undefined when calling createStudyGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/grants`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGrantRequestToJSON(requestParameters['createGrantRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrantItemFromJSON(jsonValue));
    }

    /**
     * Grant by email: a person CDR has not seen yet gets a pending principal, and the grant applies at their first sign-in. Returns 201 for a new grant and 200 when the person already holds that set here. Needs manage_assignments on the target. A study accepts internal sets only; its grants cover every DTA in the study.
     * Grant a person a capability set on a study
     */
    async createStudyGrant(requestParameters: CreateStudyGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantItem> {
        const response = await this.createStudyGrantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Needs manage_vendors.
     * Add a vendor organization
     */
    async createVendorRaw(requestParameters: CreateVendorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vendor>> {
        if (requestParameters['createVendorRequest'] == null) {
            throw new runtime.RequiredError(
                'createVendorRequest',
                'Required parameter "createVendorRequest" was null or undefined when calling createVendor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/vendors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVendorRequestToJSON(requestParameters['createVendorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorFromJSON(jsonValue));
    }

    /**
     * Needs manage_vendors.
     * Add a vendor organization
     */
    async createVendor(requestParameters: CreateVendorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vendor> {
        const response = await this.createVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deactivateDtaRaw(requestParameters: DeactivateDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DtaStageResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling deactivateDta().'
            );
        }

        if (requestParameters['deactivateDtaRequestBody'] == null) {
            throw new runtime.RequiredError(
                'deactivateDtaRequestBody',
                'Required parameter "deactivateDtaRequestBody" was null or undefined when calling deactivateDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/deactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeactivateDtaRequestBodyToJSON(requestParameters['deactivateDtaRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DtaStageResponseFromJSON(jsonValue));
    }

    /**
     */
    async deactivateDta(requestParameters: DeactivateDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DtaStageResponse> {
        const response = await this.deactivateDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deactivateDtaVersionRaw(requestParameters: DeactivateDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VersionActionResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling deactivateDtaVersion().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling deactivateDtaVersion().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling deactivateDtaVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}/deactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionActionResponseFromJSON(jsonValue));
    }

    /**
     */
    async deactivateDtaVersion(requestParameters: DeactivateDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VersionActionResponse> {
        const response = await this.deactivateDtaVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportStudyRunQuarantineDataRaw(requestParameters: ExportStudyRunQuarantineDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportQuarantineDataResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling exportStudyRunQuarantineData().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling exportStudyRunQuarantineData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/quarantine-export`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportQuarantineDataResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async exportStudyRunQuarantineData(requestParameters: ExportStudyRunQuarantineDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportQuarantineDataResponseContent> {
        const response = await this.exportStudyRunQuarantineDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Report who holds grants on a DTA or its study, and the DTA\'s recent audit events
     */
    async getAuditDtaStatusRaw(requestParameters: GetAuditDtaStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getAuditDtaStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dtaId'] != null) {
            queryParameters['dta_id'] = requestParameters['dtaId'];
        }

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/dta-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Report who holds grants on a DTA or its study, and the DTA\'s recent audit events
     */
    async getAuditDtaStatus(requestParameters: GetAuditDtaStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAuditDtaStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAuditReportRaw(requestParameters: GetAuditReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling getAuditReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/reports/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getAuditReport(requestParameters: GetAuditReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAuditReportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAuditSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getAuditSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAuditSummaryRaw(initOverrides);
    }

    /**
     */
    async getAuditSystemReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/system-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getAuditSystemReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAuditSystemReportRaw(initOverrides);
    }

    /**
     * Report a vendor\'s grants and the audit events they authored
     */
    async getAuditVendorActivityRaw(requestParameters: GetAuditVendorActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['vendorEmail'] == null) {
            throw new runtime.RequiredError(
                'vendorEmail',
                'Required parameter "vendorEmail" was null or undefined when calling getAuditVendorActivity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['vendorEmail'] != null) {
            queryParameters['vendor_email'] = requestParameters['vendorEmail'];
        }

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/vendor-activity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Report a vendor\'s grants and the audit events they authored
     */
    async getAuditVendorActivity(requestParameters: GetAuditVendorActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAuditVendorActivityRaw(requestParameters, initOverrides);
    }

    /**
     * Get one capability set
     */
    async getCapabilitySetRaw(requestParameters: GetCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapabilitySet>> {
        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling getCapabilitySet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/capability-sets/{capability_set}`.replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapabilitySetFromJSON(jsonValue));
    }

    /**
     * Get one capability set
     */
    async getCapabilitySet(requestParameters: GetCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapabilitySet> {
        const response = await this.getCapabilitySetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDTAAuditTrailRaw(requestParameters: GetDTAAuditTrailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDTAAuditTrail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/dtas/{dtaId}`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getDTAAuditTrail(requestParameters: GetDTAAuditTrailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getDTAAuditTrailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDaeStudyDetailRaw(requestParameters: GetDaeStudyDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DaeStudyDetailResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getDaeStudyDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DaeStudyDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDaeStudyDetail(requestParameters: GetDaeStudyDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DaeStudyDetailResponse> {
        const response = await this.getDaeStudyDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaDetailRaw(requestParameters: GetDtaDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DTADetails>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaDetail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DTADetailsFromJSON(jsonValue));
    }

    /**
     */
    async getDtaDetail(requestParameters: GetDtaDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DTADetails> {
        const response = await this.getDtaDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaIngestionSpecRaw(requestParameters: GetDtaIngestionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaIngestionSpec().'
            );
        }

        if (requestParameters['dtaId2'] == null) {
            throw new runtime.RequiredError(
                'dtaId2',
                'Required parameter "dtaId2" was null or undefined when calling getDtaIngestionSpec().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/ingestion-spec`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId2']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getDtaIngestionSpec(requestParameters: GetDtaIngestionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getDtaIngestionSpecRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDtaSigningRecordsRaw(requestParameters: GetDtaSigningRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigningRecordsResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaSigningRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/signing-records`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigningRecordsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDtaSigningRecords(requestParameters: GetDtaSigningRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigningRecordsResponse> {
        const response = await this.getDtaSigningRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaSuggestionsRaw(requestParameters: GetDtaSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DtaSuggestionsResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaSuggestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/suggestions`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DtaSuggestionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDtaSuggestions(requestParameters: GetDtaSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DtaSuggestionsResponse> {
        const response = await this.getDtaSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaThinkingStepsRaw(requestParameters: GetDtaThinkingStepsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DtaThinkingStepsResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaThinkingSteps().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/thinking-steps`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DtaThinkingStepsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDtaThinkingSteps(requestParameters: GetDtaThinkingStepsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DtaThinkingStepsResponse> {
        const response = await this.getDtaThinkingStepsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaVersionRaw(requestParameters: GetDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DTAVersion>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaVersion().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling getDtaVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions/{version}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DTAVersionFromJSON(jsonValue));
    }

    /**
     */
    async getDtaVersion(requestParameters: GetDtaVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DTAVersion> {
        const response = await this.getDtaVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaVtmfFilingsRaw(requestParameters: GetDtaVtmfFilingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VtmfFilingsResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaVtmfFilings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/vtmf/filings`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VtmfFilingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDtaVtmfFilings(requestParameters: GetDtaVtmfFilingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VtmfFilingsResponse> {
        const response = await this.getDtaVtmfFilingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDtaWorkflowStatusRaw(requestParameters: GetDtaWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowStatus>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getDtaWorkflowStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/workflow-status`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowStatusFromJSON(jsonValue));
    }

    /**
     */
    async getDtaWorkflowStatus(requestParameters: GetDtaWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowStatus> {
        const response = await this.getDtaWorkflowStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getHealthRaw(initOverrides);
    }

    /**
     * Read from the caller\'s token, with no Cedar check. The frontend picks its experience, pages and controls from this.
     * Get the caller\'s own audiences and capabilities
     */
    async getMyAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyAccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyAccessResponseFromJSON(jsonValue));
    }

    /**
     * Read from the caller\'s token, with no Cedar check. The frontend picks its experience, pages and controls from this.
     * Get the caller\'s own audiences and capabilities
     */
    async getMyAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyAccessResponse> {
        const response = await this.getMyAccessRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getNotificationSummaryRaw(requestParameters: GetNotificationSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSummaryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeTotal'] != null) {
            queryParameters['includeTotal'] = requestParameters['includeTotal'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/notifications/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNotificationSummary(requestParameters: GetNotificationSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSummaryResponse> {
        const response = await this.getNotificationSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Needs read_principal_directory.
     * Get a person and every grant they hold
     */
    async getPrincipalRaw(requestParameters: GetPrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrincipalDetail>> {
        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling getPrincipal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/principals/{principalId}`.replace(`{${"principalId"}}`, encodeURIComponent(String(requestParameters['principalId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrincipalDetailFromJSON(jsonValue));
    }

    /**
     * Needs read_principal_directory.
     * Get a person and every grant they hold
     */
    async getPrincipal(requestParameters: GetPrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrincipalDetail> {
        const response = await this.getPrincipalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProtocolRaw(requestParameters: GetProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudyProtocol>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getProtocol().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyProtocolFromJSON(jsonValue));
    }

    /**
     */
    async getProtocol(requestParameters: GetProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudyProtocol> {
        const response = await this.getProtocolRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRecordHistoryRaw(requestParameters: GetRecordHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRecordHistoryResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getRecordHistory().'
            );
        }

        if (requestParameters['tableName'] == null) {
            throw new runtime.RequiredError(
                'tableName',
                'Required parameter "tableName" was null or undefined when calling getRecordHistory().'
            );
        }

        if (requestParameters['primaryKeyValue'] == null) {
            throw new runtime.RequiredError(
                'primaryKeyValue',
                'Required parameter "primaryKeyValue" was null or undefined when calling getRecordHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables/{table_name}/records/{primary_key_value}/history`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"table_name"}}`, encodeURIComponent(String(requestParameters['tableName']))).replace(`{${"primary_key_value"}}`, encodeURIComponent(String(requestParameters['primaryKeyValue']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRecordHistoryResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getRecordHistory(requestParameters: GetRecordHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRecordHistoryResponseContent> {
        const response = await this.getRecordHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get aggregated statistics for the authenticated user
     */
    async getStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStatistics200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStatistics200ResponseFromJSON(jsonValue));
    }

    /**
     * Get aggregated statistics for the authenticated user
     */
    async getStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStatistics200Response> {
        const response = await this.getStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStudyIngestionSpecRaw(requestParameters: GetStudyIngestionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIngestionSpecResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyIngestionSpec().'
            );
        }

        if (requestParameters['specId'] == null) {
            throw new runtime.RequiredError(
                'specId',
                'Required parameter "specId" was null or undefined when calling getStudyIngestionSpec().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/ingestion-specs/{spec_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"spec_id"}}`, encodeURIComponent(String(requestParameters['specId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIngestionSpecResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getStudyIngestionSpec(requestParameters: GetStudyIngestionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIngestionSpecResponseContent> {
        const response = await this.getStudyIngestionSpecRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStudyRunRaw(requestParameters: GetStudyRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRunResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyRun().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling getStudyRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRunResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getStudyRun(requestParameters: GetStudyRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRunResponseContent> {
        const response = await this.getStudyRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStudyRunChangesRaw(requestParameters: GetStudyRunChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRunChangesResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyRunChanges().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling getStudyRunChanges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/changes`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRunChangesResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getStudyRunChanges(requestParameters: GetStudyRunChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRunChangesResponseContent> {
        const response = await this.getStudyRunChangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregate run counts and status across the study\'s data streams. Needs read_study.
     * Get ingestion run metrics for a study
     */
    async getStudyRunMetricsRaw(requestParameters: GetStudyRunMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRunMetricsResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyRunMetrics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/metrics`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRunMetricsResponseContentFromJSON(jsonValue));
    }

    /**
     * Aggregate run counts and status across the study\'s data streams. Needs read_study.
     * Get ingestion run metrics for a study
     */
    async getStudyRunMetrics(requestParameters: GetStudyRunMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRunMetricsResponseContent> {
        const response = await this.getStudyRunMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStudyRunQuarantineDataRaw(requestParameters: GetStudyRunQuarantineDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetQuarantineDataResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyRunQuarantineData().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling getStudyRunQuarantineData().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}/quarantine-data`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuarantineDataResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getStudyRunQuarantineData(requestParameters: GetStudyRunQuarantineDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetQuarantineDataResponseContent> {
        const response = await this.getStudyRunQuarantineDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStudyTableDataRaw(requestParameters: GetStudyTableDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTableDataResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling getStudyTableData().'
            );
        }

        if (requestParameters['tableName'] == null) {
            throw new runtime.RequiredError(
                'tableName',
                'Required parameter "tableName" was null or undefined when calling getStudyTableData().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables/{table_name}/data`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"table_name"}}`, encodeURIComponent(String(requestParameters['tableName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTableDataResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async getStudyTableData(requestParameters: GetStudyTableDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTableDataResponseContent> {
        const response = await this.getStudyTableDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTerminologyByCodeRaw(requestParameters: GetTerminologyByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getTerminologyByCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/terminology-library/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getTerminologyByCode(requestParameters: GetTerminologyByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getTerminologyByCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Needs read_vendor.
     * Get a vendor organization
     */
    async getVendorRaw(requestParameters: GetVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vendor>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling getVendor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorFromJSON(jsonValue));
    }

    /**
     * Needs read_vendor.
     * Get a vendor organization
     */
    async getVendor(requestParameters: GetVendorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vendor> {
        const response = await this.getVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getWorkflowDiagramRaw(requestParameters: GetWorkflowDiagramRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowDiagram>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling getWorkflowDiagram().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/workflow-diagram`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowDiagramFromJSON(jsonValue));
    }

    /**
     */
    async getWorkflowDiagram(requestParameters: GetWorkflowDiagramRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowDiagram> {
        const response = await this.getWorkflowDiagramRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listAllDtasRaw(requestParameters: ListAllDtasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DtaListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DtaListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listAllDtas(requestParameters: ListAllDtasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DtaListResponse> {
        const response = await this.listAllDtasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listAuditReportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async listAuditReports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listAuditReportsRaw(initOverrides);
    }

    /**
     * Open to any signed-in user, so the grant dialog can show what each set allows.
     * List the deployment\'s capability sets
     */
    async listCapabilitySetsRaw(requestParameters: ListCapabilitySetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapabilitySetListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/capability-sets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapabilitySetListResponseFromJSON(jsonValue));
    }

    /**
     * Open to any signed-in user, so the grant dialog can show what each set allows.
     * List the deployment\'s capability sets
     */
    async listCapabilitySets(requestParameters: ListCapabilitySetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapabilitySetListResponse> {
        const response = await this.listCapabilitySetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDaeNotificationsRaw(requestParameters: ListDaeNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DaeNotificationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DaeNotificationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDaeNotifications(requestParameters: ListDaeNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DaeNotificationsResponse> {
        const response = await this.listDaeNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDaeStudiesRaw(requestParameters: ListDaeStudiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DaeStudiesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DaeStudiesResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDaeStudies(requestParameters: ListDaeStudiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DaeStudiesResponse> {
        const response = await this.listDaeStudiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDtaApprovalsRaw(requestParameters: ListDtaApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDtaApprovals200Response>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaApprovals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['stage'] != null) {
            queryParameters['stage'] = requestParameters['stage'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approvals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDtaApprovals200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDtaApprovals(requestParameters: ListDtaApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDtaApprovals200Response> {
        const response = await this.listDtaApprovalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDtaCommentsRaw(requestParameters: ListDtaCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommentsListResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaComments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['section'] != null) {
            queryParameters['section'] = requestParameters['section'];
        }

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/comments`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommentsListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDtaComments(requestParameters: ListDtaCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommentsListResponse> {
        const response = await this.listDtaCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The members of the DTA\'s vendor company that CDR knows. Needs read_vendor on the DTA. Granting access is POST /dtas/{dta_id}/grants.
     * List the DTA vendor\'s known users, to suggest as grantees
     */
    async listDtaGrantCandidatesRaw(requestParameters: ListDtaGrantCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorUserListResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaGrantCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grant-candidates`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorUserListResponseFromJSON(jsonValue));
    }

    /**
     * The members of the DTA\'s vendor company that CDR knows. Needs read_vendor on the DTA. Granting access is POST /dtas/{dta_id}/grants.
     * List the DTA vendor\'s known users, to suggest as grantees
     */
    async listDtaGrantCandidates(requestParameters: ListDtaGrantCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorUserListResponse> {
        const response = await this.listDtaGrantCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Callers who can manage access see revoke controls (can_manage). Callers who can read the DTA\'s study see the list read-only. Grants on the study, which also cover the DTA, are listed by GET /studies/{study_id}/grants.
     * List the grants on a DTA
     */
    async listDtaGrantsRaw(requestParameters: ListDtaGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantListResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaGrants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grants`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrantListResponseFromJSON(jsonValue));
    }

    /**
     * Callers who can manage access see revoke controls (can_manage). Callers who can read the DTA\'s study see the list read-only. Grants on the study, which also cover the DTA, are listed by GET /studies/{study_id}/grants.
     * List the grants on a DTA
     */
    async listDtaGrants(requestParameters: ListDtaGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantListResponse> {
        const response = await this.listDtaGrantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDtaProposalsRaw(requestParameters: ListDtaProposalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProposalsListResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaProposals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['section'] != null) {
            queryParameters['section'] = requestParameters['section'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/proposals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProposalsListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDtaProposals(requestParameters: ListDtaProposalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProposalsListResponse> {
        const response = await this.listDtaProposalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listDtaVersionsRaw(requestParameters: ListDtaVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DTAVersionsResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling listDtaVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/versions`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DTAVersionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listDtaVersions(requestParameters: ListDtaVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DTAVersionsResponse> {
        const response = await this.listDtaVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listIngestionSpecsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/ingestion-specs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async listIngestionSpecs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listIngestionSpecsRaw(initOverrides);
    }

    /**
     * With each person\'s company, Active or Pending status and grant count. Needs read_principal_directory.
     * List everyone CDR has a record of
     */
    async listPrincipalsRaw(requestParameters: ListPrincipalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrincipalListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/principals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrincipalListResponseFromJSON(jsonValue));
    }

    /**
     * With each person\'s company, Active or Pending status and grant count. Needs read_principal_directory.
     * List everyone CDR has a record of
     */
    async listPrincipals(requestParameters: ListPrincipalsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrincipalListResponse> {
        const response = await this.listPrincipalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyAuditEventsRaw(requestParameters: ListStudyAuditEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyAuditEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/studies/{studyId}`.replace(`{${"studyId"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async listStudyAuditEvents(requestParameters: ListStudyAuditEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listStudyAuditEventsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async listStudyDataStreamsRaw(requestParameters: ListStudyDataStreamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDataStreamsResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyDataStreams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/data-streams`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDataStreamsResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async listStudyDataStreams(requestParameters: ListStudyDataStreamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDataStreamsResponseContent> {
        const response = await this.listStudyDataStreamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyDtasRaw(requestParameters: ListStudyDtasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudyDtaListResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyDtas().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['vendor'] != null) {
            queryParameters['vendor'] = requestParameters['vendor'];
        }

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyDtaListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listStudyDtas(requestParameters: ListStudyDtasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudyDtaListResponse> {
        const response = await this.listStudyDtasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Callers who can manage access see revoke controls (can_manage). Callers who can read the study see the list read-only.
     * List the grants on a study
     */
    async listStudyGrantsRaw(requestParameters: ListStudyGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantListResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyGrants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/grants`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrantListResponseFromJSON(jsonValue));
    }

    /**
     * Callers who can manage access see revoke controls (can_manage). Callers who can read the study see the list read-only.
     * List the grants on a study
     */
    async listStudyGrants(requestParameters: ListStudyGrantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantListResponse> {
        const response = await this.listStudyGrantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyIngestionSpecsRaw(requestParameters: ListStudyIngestionSpecsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListIngestionSpecsResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyIngestionSpecs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/ingestion-specs`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListIngestionSpecsResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async listStudyIngestionSpecs(requestParameters: ListStudyIngestionSpecsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListIngestionSpecsResponseContent> {
        const response = await this.listStudyIngestionSpecsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyInsightsRaw(requestParameters: ListStudyInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInsightsResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyInsights().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/insights`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInsightsResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async listStudyInsights(requestParameters: ListStudyInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInsightsResponseContent> {
        const response = await this.listStudyInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyRunsRaw(requestParameters: ListStudyRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRunsResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyRuns().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['specId'] != null) {
            queryParameters['specId'] = requestParameters['specId'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRunsResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async listStudyRuns(requestParameters: ListStudyRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRunsResponseContent> {
        const response = await this.listStudyRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listStudyTablesRaw(requestParameters: ListStudyTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTablesResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling listStudyTables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/tables`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTablesResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async listStudyTables(requestParameters: ListStudyTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTablesResponseContent> {
        const response = await this.listStudyTablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listTerminologyLibraryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminologyLibraryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/terminology-library`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminologyLibraryResponseFromJSON(jsonValue));
    }

    /**
     */
    async listTerminologyLibrary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminologyLibraryResponse> {
        const response = await this.listTerminologyLibraryRaw(initOverrides);
        return await response.value();
    }

    /**
     * List the audit events one actor authored. `userId` is the actor\'s principal_id, which survives an email change; the principal directory (`GET /api/v1/principals`) maps an email to it. An actor with no principal has a prefixed id instead: `subject:<auth_subject>`, `sftp:<username>` or `system:<name>`.
     */
    async listUserAuditEventsRaw(requestParameters: ListUserAuditEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling listUserAuditEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audits/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * List the audit events one actor authored. `userId` is the actor\'s principal_id, which survives an email change; the principal directory (`GET /api/v1/principals`) maps an email to it. An actor with no principal has a prefixed id instead: `subject:<auth_subject>`, `sftp:<username>` or `system:<name>`.
     */
    async listUserAuditEvents(requestParameters: ListUserAuditEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listUserAuditEventsRaw(requestParameters, initOverrides);
    }

    /**
     * The people linked to this vendor company. Needs read_vendor.
     * List a vendor\'s users
     */
    async listVendorUsersRaw(requestParameters: ListVendorUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorUserListResponse>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling listVendorUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}/users`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorUserListResponseFromJSON(jsonValue));
    }

    /**
     * The people linked to this vendor company. Needs read_vendor.
     * List a vendor\'s users
     */
    async listVendorUsers(requestParameters: ListVendorUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorUserListResponse> {
        const response = await this.listVendorUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The vendor registry. Needs read_vendor.
     * List vendor organizations
     */
    async listVendorsRaw(requestParameters: ListVendorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendorListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['nextToken'] != null) {
            queryParameters['next_token'] = requestParameters['nextToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorListResponseFromJSON(jsonValue));
    }

    /**
     * The vendor registry. Needs read_vendor.
     * List vendor organizations
     */
    async listVendors(requestParameters: ListVendorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendorListResponse> {
        const response = await this.listVendorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async logAuditActivityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/activity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logAuditActivity(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logAuditActivityRaw(initOverrides);
    }

    /**
     */
    async logAuditSecurityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/security`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logAuditSecurity(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logAuditSecurityRaw(initOverrides);
    }

    /**
     */
    async markNotificationsReadBatchRaw(requestParameters: MarkNotificationsReadBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['markNotificationsReadBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'markNotificationsReadBatchRequest',
                'Required parameter "markNotificationsReadBatchRequest" was null or undefined when calling markNotificationsReadBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/notifications/read`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkNotificationsReadBatchRequestToJSON(requestParameters['markNotificationsReadBatchRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markNotificationsReadBatch(requestParameters: MarkNotificationsReadBatchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markNotificationsReadBatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async parseEdcFileRaw(requestParameters: ParseEdcFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParseSpecResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling parseEdcFile().'
            );
        }

        if (requestParameters['parseEdcFileRequest'] == null) {
            throw new runtime.RequiredError(
                'parseEdcFileRequest',
                'Required parameter "parseEdcFileRequest" was null or undefined when calling parseEdcFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/parse-edc`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParseEdcFileRequestToJSON(requestParameters['parseEdcFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParseSpecResponseFromJSON(jsonValue));
    }

    /**
     */
    async parseEdcFile(requestParameters: ParseEdcFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParseSpecResponse> {
        const response = await this.parseEdcFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async parseSdtmFileRaw(requestParameters: ParseSdtmFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParseSpecResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling parseSdtmFile().'
            );
        }

        if (requestParameters['parseEdcFileRequest'] == null) {
            throw new runtime.RequiredError(
                'parseEdcFileRequest',
                'Required parameter "parseEdcFileRequest" was null or undefined when calling parseSdtmFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/parse-sdtm`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParseEdcFileRequestToJSON(requestParameters['parseEdcFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParseSpecResponseFromJSON(jsonValue));
    }

    /**
     */
    async parseSdtmFile(requestParameters: ParseSdtmFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParseSpecResponse> {
        const response = await this.parseSdtmFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postProtocolRaw(requestParameters: PostProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudyProtocol>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling postProtocol().'
            );
        }

        if (requestParameters['createProtocolRequest'] == null) {
            throw new runtime.RequiredError(
                'createProtocolRequest',
                'Required parameter "createProtocolRequest" was null or undefined when calling postProtocol().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProtocolRequestToJSON(requestParameters['createProtocolRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyProtocolFromJSON(jsonValue));
    }

    /**
     */
    async postProtocol(requestParameters: PostProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudyProtocol> {
        const response = await this.postProtocolRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async presignDocumentUploadRaw(requestParameters: PresignDocumentUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresignDocumentUpload200Response>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling presignDocumentUpload().'
            );
        }

        if (requestParameters['presignUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'presignUploadRequest',
                'Required parameter "presignUploadRequest" was null or undefined when calling presignDocumentUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/documents/presign`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresignUploadRequestToJSON(requestParameters['presignUploadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresignDocumentUpload200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async presignDocumentUpload(requestParameters: PresignDocumentUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresignDocumentUpload200Response> {
        const response = await this.presignDocumentUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit DTA for review (DRAFT -> REVIEW)
     */
    async publishDtaRaw(requestParameters: PublishDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivateDtaWorkflow201Response>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling publishDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/publish`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateDtaWorkflowRequestToJSON(requestParameters['activateDtaWorkflowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivateDtaWorkflow201ResponseFromJSON(jsonValue));
    }

    /**
     * Submit DTA for review (DRAFT -> REVIEW)
     */
    async publishDta(requestParameters: PublishDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivateDtaWorkflow201Response> {
        const response = await this.publishDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async putProtocolRaw(requestParameters: PutProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudyProtocol>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling putProtocol().'
            );
        }

        if (requestParameters['updateProtocolRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProtocolRequest',
                'Required parameter "updateProtocolRequest" was null or undefined when calling putProtocol().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProtocolRequestToJSON(requestParameters['updateProtocolRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyProtocolFromJSON(jsonValue));
    }

    /**
     */
    async putProtocol(requestParameters: PutProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudyProtocol> {
        const response = await this.putProtocolRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reactivateDtaRaw(requestParameters: ReactivateDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DtaStageResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling reactivateDta().'
            );
        }

        if (requestParameters['reactivateDtaRequestBody'] == null) {
            throw new runtime.RequiredError(
                'reactivateDtaRequestBody',
                'Required parameter "reactivateDtaRequestBody" was null or undefined when calling reactivateDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/reactivate`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReactivateDtaRequestBodyToJSON(requestParameters['reactivateDtaRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DtaStageResponseFromJSON(jsonValue));
    }

    /**
     */
    async reactivateDta(requestParameters: ReactivateDtaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DtaStageResponse> {
        const response = await this.reactivateDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async rejectApprovalRaw(requestParameters: RejectApprovalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowApproval>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling rejectApproval().'
            );
        }

        if (requestParameters['approvalId'] == null) {
            throw new runtime.RequiredError(
                'approvalId',
                'Required parameter "approvalId" was null or undefined when calling rejectApproval().'
            );
        }

        if (requestParameters['rejectApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectApprovalRequest',
                'Required parameter "rejectApprovalRequest" was null or undefined when calling rejectApproval().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approvals/{approval_id}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"approval_id"}}`, encodeURIComponent(String(requestParameters['approvalId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RejectApprovalRequestToJSON(requestParameters['rejectApprovalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowApprovalFromJSON(jsonValue));
    }

    /**
     */
    async rejectApproval(requestParameters: RejectApprovalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowApproval> {
        const response = await this.rejectApprovalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a person from a vendor company; refused if they have since moved to another
     */
    async removeVendorUserRaw(requestParameters: RemoveVendorUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling removeVendorUser().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling removeVendorUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}/users/{principalId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))).replace(`{${"principalId"}}`, encodeURIComponent(String(requestParameters['principalId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a person from a vendor company; refused if they have since moved to another
     */
    async removeVendorUser(requestParameters: RemoveVendorUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeVendorUserRaw(requestParameters, initOverrides);
    }

    /**
     * Needs manage_assignments on the DTA. A caller cannot revoke their own grant.
     * Revoke a person\'s capability set on a DTA
     */
    async revokeDtaGrantRaw(requestParameters: RevokeDtaGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling revokeDtaGrant().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling revokeDtaGrant().'
            );
        }

        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling revokeDtaGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/grants/{principal_id}/{capability_set}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"principal_id"}}`, encodeURIComponent(String(requestParameters['principalId']))).replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Needs manage_assignments on the DTA. A caller cannot revoke their own grant.
     * Revoke a person\'s capability set on a DTA
     */
    async revokeDtaGrant(requestParameters: RevokeDtaGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeDtaGrantRaw(requestParameters, initOverrides);
    }

    /**
     * Needs manage_assignments on the study. A caller cannot revoke their own grant.
     * Revoke a person\'s capability set on a study
     */
    async revokeStudyGrantRaw(requestParameters: RevokeStudyGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling revokeStudyGrant().'
            );
        }

        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling revokeStudyGrant().'
            );
        }

        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling revokeStudyGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/grants/{principal_id}/{capability_set}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"principal_id"}}`, encodeURIComponent(String(requestParameters['principalId']))).replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Needs manage_assignments on the study. A caller cannot revoke their own grant.
     * Revoke a person\'s capability set on a study
     */
    async revokeStudyGrant(requestParameters: RevokeStudyGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeStudyGrantRaw(requestParameters, initOverrides);
    }

    /**
     */
    async searchAuditRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/audit/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async searchAudit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.searchAuditRaw(initOverrides);
    }

    /**
     */
    async signDtaRaw(requestParameters: SignDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SigningRecord>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling signDta().'
            );
        }

        if (requestParameters['signDtaRequest'] == null) {
            throw new runtime.RequiredError(
                'signDtaRequest',
                'Required parameter "signDtaRequest" was null or undefined when calling signDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/signing-records`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignDtaRequestToJSON(requestParameters['signDtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SigningRecordFromJSON(jsonValue));
    }

    /**
     */
    async signDta(requestParameters: SignDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SigningRecord> {
        const response = await this.signDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async submitApprovalRaw(requestParameters: SubmitApprovalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowApproval>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling submitApproval().'
            );
        }

        if (requestParameters['submitApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'submitApprovalRequest',
                'Required parameter "submitApprovalRequest" was null or undefined when calling submitApproval().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/approvals`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitApprovalRequestToJSON(requestParameters['submitApprovalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowApprovalFromJSON(jsonValue));
    }

    /**
     */
    async submitApproval(requestParameters: SubmitApprovalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowApproval> {
        const response = await this.submitApprovalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async syncIngestionSpecStatusRaw(requestParameters: SyncIngestionSpecStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling syncIngestionSpecStatus().'
            );
        }

        if (requestParameters['dtaId2'] == null) {
            throw new runtime.RequiredError(
                'dtaId2',
                'Required parameter "dtaId2" was null or undefined when calling syncIngestionSpecStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/ingestion-spec/sync-status`.replace(`{${"dtaId"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId2']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async syncIngestionSpecStatus(requestParameters: SyncIngestionSpecStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.syncIngestionSpecStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async triggerDtaVtmfFilingRaw(requestParameters: TriggerDtaVtmfFilingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VtmfFilingActionResponse>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling triggerDtaVtmfFiling().'
            );
        }

        if (requestParameters['triggerVtmfFilingRequest'] == null) {
            throw new runtime.RequiredError(
                'triggerVtmfFilingRequest',
                'Required parameter "triggerVtmfFilingRequest" was null or undefined when calling triggerDtaVtmfFiling().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/vtmf/filings`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerVtmfFilingRequestToJSON(requestParameters['triggerVtmfFilingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VtmfFilingActionResponseFromJSON(jsonValue));
    }

    /**
     */
    async triggerDtaVtmfFiling(requestParameters: TriggerDtaVtmfFilingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VtmfFilingActionResponse> {
        const response = await this.triggerDtaVtmfFilingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Needs manage_capability_sets, and is refused unless the deployment turns capability-set editing on. Sets from the manifest cannot be edited here.
     * Edit an admin-owned capability set
     */
    async updateCapabilitySetRaw(requestParameters: UpdateCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CapabilitySet>> {
        if (requestParameters['capabilitySet'] == null) {
            throw new runtime.RequiredError(
                'capabilitySet',
                'Required parameter "capabilitySet" was null or undefined when calling updateCapabilitySet().'
            );
        }

        if (requestParameters['capabilitySetRequest'] == null) {
            throw new runtime.RequiredError(
                'capabilitySetRequest',
                'Required parameter "capabilitySetRequest" was null or undefined when calling updateCapabilitySet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/capability-sets/{capability_set}`.replace(`{${"capability_set"}}`, encodeURIComponent(String(requestParameters['capabilitySet']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CapabilitySetRequestToJSON(requestParameters['capabilitySetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CapabilitySetFromJSON(jsonValue));
    }

    /**
     * Needs manage_capability_sets, and is refused unless the deployment turns capability-set editing on. Sets from the manifest cannot be edited here.
     * Edit an admin-owned capability set
     */
    async updateCapabilitySet(requestParameters: UpdateCapabilitySetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CapabilitySet> {
        const response = await this.updateCapabilitySetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCommentRaw(requestParameters: UpdateCommentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Comment>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling updateComment().'
            );
        }

        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError(
                'commentId',
                'Required parameter "commentId" was null or undefined when calling updateComment().'
            );
        }

        if (requestParameters['updateCommentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCommentRequest',
                'Required parameter "updateCommentRequest" was null or undefined when calling updateComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/comments/{commentId}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCommentRequestToJSON(requestParameters['updateCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommentFromJSON(jsonValue));
    }

    /**
     */
    async updateComment(requestParameters: UpdateCommentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Comment> {
        const response = await this.updateCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDtaRaw(requestParameters: UpdateDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DTADetails>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling updateDta().'
            );
        }

        if (requestParameters['updateDtaRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDtaRequest',
                'Required parameter "updateDtaRequest" was null or undefined when calling updateDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDtaRequestToJSON(requestParameters['updateDtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DTADetailsFromJSON(jsonValue));
    }

    /**
     */
    async updateDta(requestParameters: UpdateDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DTADetails> {
        const response = await this.updateDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change a principal\'s fields. Only the fields the body names are changed.
     */
    async updatePrincipalRaw(requestParameters: UpdatePrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrincipalDetail>> {
        if (requestParameters['principalId'] == null) {
            throw new runtime.RequiredError(
                'principalId',
                'Required parameter "principalId" was null or undefined when calling updatePrincipal().'
            );
        }

        if (requestParameters['principalUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'principalUpdateRequest',
                'Required parameter "principalUpdateRequest" was null or undefined when calling updatePrincipal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/principals/{principalId}`.replace(`{${"principalId"}}`, encodeURIComponent(String(requestParameters['principalId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PrincipalUpdateRequestToJSON(requestParameters['principalUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrincipalDetailFromJSON(jsonValue));
    }

    /**
     * Change a principal\'s fields. Only the fields the body names are changed.
     */
    async updatePrincipal(requestParameters: UpdatePrincipalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrincipalDetail> {
        const response = await this.updatePrincipalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateProposalRaw(requestParameters: UpdateProposalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Proposal>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling updateProposal().'
            );
        }

        if (requestParameters['proposalId'] == null) {
            throw new runtime.RequiredError(
                'proposalId',
                'Required parameter "proposalId" was null or undefined when calling updateProposal().'
            );
        }

        if (requestParameters['updateProposalRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProposalRequest',
                'Required parameter "updateProposalRequest" was null or undefined when calling updateProposal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/proposals/{proposalId}`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))).replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters['proposalId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProposalRequestToJSON(requestParameters['updateProposalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProposalFromJSON(jsonValue));
    }

    /**
     */
    async updateProposal(requestParameters: UpdateProposalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Proposal> {
        const response = await this.updateProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateStudyRunRaw(requestParameters: UpdateStudyRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateRunResponseContent>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling updateStudyRun().'
            );
        }

        if (requestParameters['runId'] == null) {
            throw new runtime.RequiredError(
                'runId',
                'Required parameter "runId" was null or undefined when calling updateStudyRun().'
            );
        }

        if (requestParameters['updateRunRequestContent'] == null) {
            throw new runtime.RequiredError(
                'updateRunRequestContent',
                'Required parameter "updateRunRequestContent" was null or undefined when calling updateStudyRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/runs/{run_id}`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))).replace(`{${"run_id"}}`, encodeURIComponent(String(requestParameters['runId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRunRequestContentToJSON(requestParameters['updateRunRequestContent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateRunResponseContentFromJSON(jsonValue));
    }

    /**
     */
    async updateStudyRun(requestParameters: UpdateStudyRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateRunResponseContent> {
        const response = await this.updateStudyRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Only the fields the body names are changed. Needs manage_vendors.
     * Update a vendor organization
     */
    async updateVendorRaw(requestParameters: UpdateVendorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vendor>> {
        if (requestParameters['vendorId'] == null) {
            throw new runtime.RequiredError(
                'vendorId',
                'Required parameter "vendorId" was null or undefined when calling updateVendor().'
            );
        }

        if (requestParameters['updateVendorRequest'] == null) {
            throw new runtime.RequiredError(
                'updateVendorRequest',
                'Required parameter "updateVendorRequest" was null or undefined when calling updateVendor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/vendors/{vendorId}`.replace(`{${"vendorId"}}`, encodeURIComponent(String(requestParameters['vendorId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVendorRequestToJSON(requestParameters['updateVendorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendorFromJSON(jsonValue));
    }

    /**
     * Only the fields the body names are changed. Needs manage_vendors.
     * Update a vendor organization
     */
    async updateVendor(requestParameters: UpdateVendorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vendor> {
        const response = await this.updateVendorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadDtaFileRaw(requestParameters: UploadDtaFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling uploadDtaFile().'
            );
        }

        if (requestParameters['uploadDtaFileRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadDtaFileRequest',
                'Required parameter "uploadDtaFileRequest" was null or undefined when calling uploadDtaFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/dtas/upload`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadDtaFileRequestToJSON(requestParameters['uploadDtaFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadDtaFile(requestParameters: UploadDtaFileOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadResponse> {
        const response = await this.uploadDtaFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadProtocolRaw(requestParameters: UploadProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProtocolUploadResponse>> {
        if (requestParameters['studyId'] == null) {
            throw new runtime.RequiredError(
                'studyId',
                'Required parameter "studyId" was null or undefined when calling uploadProtocol().'
            );
        }

        if (requestParameters['uploadProtocolFileRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadProtocolFileRequest',
                'Required parameter "uploadProtocolFileRequest" was null or undefined when calling uploadProtocol().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/studies/{study_id}/protocol/upload`.replace(`{${"study_id"}}`, encodeURIComponent(String(requestParameters['studyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadProtocolFileRequestToJSON(requestParameters['uploadProtocolFileRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProtocolUploadResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadProtocol(requestParameters: UploadProtocolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProtocolUploadResponse> {
        const response = await this.uploadProtocolRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadToDtaRaw(requestParameters: UploadToDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadToDta200Response>> {
        if (requestParameters['dtaId'] == null) {
            throw new runtime.RequiredError(
                'dtaId',
                'Required parameter "dtaId" was null or undefined when calling uploadToDta().'
            );
        }

        if (requestParameters['uploadToDtaRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadToDtaRequest',
                'Required parameter "uploadToDtaRequest" was null or undefined when calling uploadToDta().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/dtas/{dta_id}/upload`.replace(`{${"dta_id"}}`, encodeURIComponent(String(requestParameters['dtaId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadToDtaRequestToJSON(requestParameters['uploadToDtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadToDta200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadToDta(requestParameters: UploadToDtaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadToDta200Response> {
        const response = await this.uploadToDtaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
